import type { RegenerablePdfTemplate, RegenerateTemplateEntry } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";

/**
 * Maintenance calls for regenerating the stored ticket/badge PDF templates of an
 * event. Restricted to the AC EXPO role on the backend. Each PDF is regenerated in
 * the browser and uploaded via the standard presigned flow; the stored files are
 * then swapped in one atomic batch.
 */
export const getEventPdfTemplates = async (
  eventId: string
): Promise<RegenerablePdfTemplate[]> => {
  const res = await privateAxios.get<RegenerablePdfTemplate[]>("/maintenance/pdf-templates", {
    params: { eventId },
  });
  return res.data;
};

export const regeneratePdfTemplatesBatch = async (
  eventId: string,
  entries: RegenerateTemplateEntry[]
): Promise<{ keys: string[] }> => {
  const res = await privateAxios.post<{ keys: string[] }>(
    "/maintenance/pdf-templates/regenerate-batch",
    { eventId, entries }
  );
  return res.data;
};
